import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './ScreenItem.module.scss'
import no_thumbnail from '../../img/no-thumbnail.png'
import video_thumbnail from '../../img/video-thumbnail.png'

const ScreenItem = ({ screen: { id, title, field_playlist_reference } }) => {
  const playlist_reference = field_playlist_reference

  if (!playlist_reference.hasOwnProperty('field_playlist')) {
    return (
      <div className={styles['screen-item']}>
        <div className={styles['screen-item__link']}>No Playlist</div>
        <h3>{title}</h3>
      </div>
    )
  }

  const playlist = playlist_reference.field_playlist
  const playlistLength = playlist.length - 1

  const playlistType = playlist.slice(0, 1).map((item) => {
    const type = item.type
    return type
  })

  return (
    <div className={styles['screen-item']}>
      <Link to={`/screen/${id}`} className={styles['screen-item__link']}>
        {playlistType[0] === 'media--image' ? (
          playlist
            .slice(0, 1)
            .map((image, index) => (
              <img
                key={index}
                src={
                  image.field_media_image?.links?.screen_thumbnail?.href ||
                  no_thumbnail
                }
                alt=''
              />
            ))
        ) : (
          <img src={video_thumbnail} alt='' />
        )}

        {playlistLength > 0 ? (
          <div className={styles['playlist-remainder']}>+{playlistLength}</div>
        ) : (
          ''
        )}
      </Link>
      <h3>{title}</h3>
    </div>
  )
}

ScreenItem.propTypes = {
  screen: PropTypes.object.isRequired,
}

export default ScreenItem
